module.exports = __webpack_public_path__ + "img/ex18.2850817f.png";